/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-013 10:03:10
 *
 *******************************************************/

export const CROSS_SELL_UP_SELL = {
  addon: {
    'AI-powered-search': 'aiPowerSearch',
    'visual-merchandising': 'visualMerchandising',
    'AI-powered-recommendation': 'aiPowerRecommendation',
    'sync-frequency': 'syncFrequency',
    'variant-display': 'variantDisplay',
    'analytics-180-days': 'analytics',
    'analytics-365-days': 'analytics'
  }
};
